import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SessionStorageService } from '../services/session-storage.service';
import { SessionExpiredService } from '../services/session-expired.service';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionStorageService = inject(SessionStorageService);
  const sessionExpiredService = inject(SessionExpiredService);
  const auth = sessionStorageService.getItem('auth') as { loginToken: string };

  let handledReq = req;
  if (auth) {
    handledReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${auth.loginToken}`
      }
    });
  }

  return next(handledReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const isLoggedIn = !!sessionStorageService.getItem('auth');
      if (error.status === 401 && !req.url.includes('/login') && isLoggedIn) {
        sessionExpiredService.trigger();
      }
      return throwError(() => error);
    })
  );
};
